import { render, staticRenderFns } from "./posTransView.vue?vue&type=template&id=6448e13c&"
import script from "./posTransView.vue?vue&type=script&lang=js&"
export * from "./posTransView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports